// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__7wjgP","large":"styles_large__2W_DG"};